export default __webpack_public_path__ + "static/media/award.9d0ff98c.svg";